import React from "react";
import { NavLink } from "react-router-dom";
import { Toolbar,AppBar,Tabs,Tab,Button,useMediaQuery,useTheme } from "@mui/material";
import DrawerComp from "./Drawer.jsx";



function Nav() {
  const theme = useTheme();
  const isMatch = useMediaQuery(theme.breakpoints.down('md'));
  return (
    
    <AppBar position="static" color="secondary">
      <Toolbar>
        cellular connections
        {isMatch ? (
           <DrawerComp  />
        ) : (
          <>
          <Tabs   >
          <NavLink to="/" ><Tab label="Home" id="nav-text" ></Tab></NavLink>
          <NavLink to="/Product"><Tab label="Product" id="nav-text" ></Tab></NavLink>
          <NavLink to="/contact"><Tab label="contact" id="nav-text" ></Tab></NavLink>
          </Tabs>
          </>
        )}
          </Toolbar>
    </AppBar>
  );
}

export default Nav;
